import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/strategic_partnerships.json";

export const useStrategicPartnerships = ({ featured = null } = {}) => useSourceFlowCollection(data);

export default useStrategicPartnerships;
